import React from 'react';

import Icon from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';

type AutomationGlyphProps = {
	primaryColor?: string;
};
const AutomationGlyph = ({
	primaryColor = `${token('color.icon.accent.blue', '#388BFF')}`,
}: AutomationGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			backgroundColor: token('color.background.accent.blue.subtlest', '#E9F2FF'),
		}}
	>
		<path d="M14 5L10 19" stroke={primaryColor} strokeWidth="2" strokeLinecap="round" fill="none" />
		<path
			d="M14 5L7 12H17L10 19"
			stroke={primaryColor}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none"
		/>
	</svg>
);

export const AutomationIcon = (props: AutomationGlyphProps) => {
	const glyph = () => <AutomationGlyph {...props} />;
	// Will remove following eslint disable upon completion of https://product-fabric.atlassian.net/browse/CCECO-3942
	// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
	return <Icon glyph={glyph} label="Lightning filled icon" />;
};
